<profile-section>
  <ng-container slot="title" i18n> Compétences </ng-container>

  <div class="hard-skills__container">
    <profile-hard-skill
      *ngFor="let skill of profile?.hardSkills; let i = index; trackBy: trackByIndex"
      [skill]="skill"
      class="hard-skills__item"
      [loading]="!profile?.hardSkills.includes(skill) && loading"
    ></profile-hard-skill>
  </div>
</profile-section>
